import classNames from "classnames";
import messages from "i18n/messages";
import flowRight from "lodash/flowRight";
import {
  makeSelectOrderById,
  updateOrderAttr,
  makeSelectBookingType,
} from "logic/orders";
import { withRouter } from "next/router";
import { makeSelectCurOrg } from "logic/orgs";
import { Component } from "react";
import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Col, FormGroup, FormText, Input, Label, Row } from "reactstrap";
import { makeSelectDateById } from "logic/dates";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";

const DeliveryCosts = ({ deliveryMethod, order, onChange, org }) => (
  <Col xs={12}>
    <FormGroup check className="form-check-radio">
      <Label check>
        <Input
          type="radio"
          name="delivery_method"
          value={deliveryMethod.name}
          checked={order.delivery_method === deliveryMethod.name}
          onChange={onChange}
        />
        <span className="form-check-sign" />
        <FormattedMessage
          {...messages[`deliveryMethod${deliveryMethod.name}`]}
        />
        <FormText>
          <FormattedMessage
            {...messages[`deliveryMethod${deliveryMethod.name}Desc`]}
          />
        </FormText>
        {deliveryMethod.amount && deliveryMethod.amount > 0 ? (
          <FormText>
            <FormattedMessage
              {...messages.additionalFees}
              values={{
                fees: (
                  <FormattedNumber
                    value={deliveryMethod.amount / 100}
                    currency={org.currency}
                    style={`currency`}
                  />
                ),
              }}
            />
          </FormText>
        ) : null}
      </Label>
    </FormGroup>
  </Col>
);

const BicycleInfo = ({ collapseShipping, handleToggleShipping, date }) => (
  <div
    className={classNames("delivery-methods", { collapsed: collapseShipping })}
  >
    <div className="section-header">
      <h2>
        <FormattedMessage {...messages.shipping} />
      </h2>
      <div className="agreed-terms">
        <FormattedMessage {...messages.shipping_bicycle} />
      </div>
      <span
        className={`tt-icon tt-icon-${collapseShipping ? "down" : "up"}-arrow`}
        onClick={handleToggleShipping}
      />
    </div>
    <div className="collapsed-content">
      <Row>
        <div
          className="p-4"
          dangerouslySetInnerHTML={{
            __html: date.pp_delivery_text,
          }}
        ></div>
      </Row>
    </div>
  </div>
);

class DeliveryMethods extends Component {
  state = {
    collapseShipping: false,
  };

  componentDidMount() {
    if (this.props.org && this.props.org.delivery_costs.length < 2)
      this.setState({ collapseShipping: true });
  }

  handleToggleCollapsedShipping = () =>
    this.setState({ collapseShipping: !this.state.collapseShipping });

  handleSetDeliveryMethod = ({ target }) =>
    this.props.actions.updateOrderAttr("delivery_method", target.value);

  render() {
    const { order, bookingType, org } = this.props;

    if (order.delivery_method === "bicycle")
      return (
        <BicycleInfo
          date={this.props.date}
          handleToggleShipping={this.handleToggleCollapsedShipping}
          collapseShipping={false}
        />
      );
    if (org.delivery_costs.length < 2) return <></>;
    if (bookingType === "res") return <></>;

    return (
      <div
        className={classNames("delivery-methods", {
          collapsed: this.state.collapseShipping,
        })}
      >
        <div className="section-header">
          <h2>
            <FormattedMessage {...messages.shipping} />
          </h2>
          <div className="agreed-terms">
            {order.delivery_method ? (
              <FormattedMessage
                {...messages[`shipping_${order.delivery_method}`]}
              />
            ) : null}
          </div>
          <span
            className={`tt-icon tt-icon-${
              this.state.collapseShipping ? "down" : "up"
            }-arrow`}
            onClick={this.handleToggleCollapsedShipping}
          />
        </div>
        <div className="collapsed-content">
          <Row>
            {org.delivery_costs.map((deliveryMethod) => (
              <DeliveryCosts
                deliveryMethod={deliveryMethod}
                key={`delivery-method-${deliveryMethod.name}`}
                org={org}
                order={order}
                onChange={this.handleSetDeliveryMethod}
              />
            ))}
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  date: makeSelectDateById((props) => props.router.query.id),
  bookingType: makeSelectBookingType(),
  order: makeSelectOrderById((props) => props.id),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateOrderAttr,
    },
    dispatch
  ),
});

const enhance = flowRight(
  injectIntl,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(DeliveryMethods);
